import React from 'react'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'

export default () => (
  <Box className="Bg-1 Flex center">
    <CircularProgress color="secondary" />
  </Box>
)
